<template>
  <div class="px-10 pt-5 pb-3 leading-base break-words survey-title" ref="info">
    <div ref="titleContainer" class="title text-20 font-bold mb-3 text-center" v-html="title"></div>
    <div ref="descContainer" class="desc box-border text-theme-black-650" v-html="welcome"></div>
  </div>
</template>

<script>
import { busGetters, defaultsSurveyAttr } from 'dygc'
import { previewImage } from '@/assets/js/preview-image'

export default {
  name: 'SurveyInfo',
  computed: {
    welcome() {
      return this.survey.welcome || ''
    },
    title() {
      return this.survey.titlex || this.survey.title
    },
    ...busGetters(['survey'])
  },
  mounted() {
    previewImage(this.$refs.info)
  }
}
</script>
